import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { LogLevel, Configuration, BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { ConfigService } from '../models/ConfigService';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

//const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');

export function initializerFactory(env: ConfigService): any {
  // APP_INITIALIZER, except a function return which will return a promise
  // APP_INITIALIZER, angular doesnt starts application untill it completes
  const promise = env.load().then((value) => {
    //console.log(env.getSettings('clientID'));
  });
  return () => promise;
}



export function MSALInstanceFactory(conf: ConfigService): IPublicClientApplication {
 
  const configuration: Configuration = {
    auth: {
      // clientId: "", // This is the ONLY mandatory field that you need to supply.
      // authority: "", // Defaults to "https://login.microsoftonline.com/common"
      // redirectUri: "", // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
     
      clientId: conf.getSettings("clientID"), // This is the ONLY mandatory field that you need to supply.
      authority: conf.getSettings("authority"), // Defaults to "https://login.microsoftonline.com/common"
      redirectUri: conf.getSettings("redirectUri"), // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
      postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback(logLevel: LogLevel, message: string) {
          //console.log(message);
        },
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false
      }
    }
  }
  return new PublicClientApplication(configuration);
}


export const silentRequest = {
  scopes: ['user.read'],
  loginHint: "example@domain.net"
};


export const loginRequest = {
  scopes: ['user.read']
};

export function MSALInterceptorConfigFactory(conf: ConfigService): MsalInterceptorConfiguration {

  const protectedResources: Map<string, Array<string>> = new Map([
    ['https://graph.microsoft.com/v1.0/me', ['user.read']],
    [
      conf.getSettings("ApiUrl"),
      [conf.getSettings("clientID") + '/user_impersonation'],
    ],
  ]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: protectedResources
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  const auth = {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest
  };
  return (auth as MsalGuardConfiguration)
}
//-------------------------------------------------------------
@NgModule({
  providers: [
  ],
  imports: [MsalModule]
})
export class MsalConfModule {
  static forRoot(): ModuleWithProviders<MsalConfModule> {
    return {
      ngModule: MsalConfModule,
      providers: [

        // { provide: AUTH_CONFIG_URL_TOKEN },
        {
          provide: APP_INITIALIZER, useFactory: initializerFactory,
          deps: [ConfigService,
            // AUTH_CONFIG_URL_TOKEN
          ],
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true,

        },
        {
          provide: MSAL_INSTANCE,
          useFactory: MSALInstanceFactory,
          deps: [ConfigService]
        },
        {
          provide: MSAL_GUARD_CONFIG,
          useFactory: MSALGuardConfigFactory
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: MSALInterceptorConfigFactory,
          deps: [ConfigService]
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService
      ],
    }
  }

}